import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const SubmitProposal = ({compensationID}) => {
  debugger
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate(); // Initialize the navigate function
  const [error, setError] = useState(null);
  const [currentStep, setCurrentStep] = useState(0);
  // const [compensationId , setCompensationId] = useState(null);

  // const fetchCompensationDetails = async () => {
  //   debugger
  //   try {

  //     console.log("Fetched CompensationId:", compensationsId );

  //     const parsedCompensationId = parseInt(compensationsId , 10);
  //     console.log("Parsed CompensationId:", parsedCompensationId); 

  //     if (isNaN(parsedCompensationId)) {
  //       console.error("Invalid CompensationId:", compensationsId );
  //       return; // Exit early if CompensationId is invalid
  //     }

  //     const response = await axios.get(
  //       `https://backurrda.sarmar.co.in/api/DetailsInsert/CompensationDetailsGet?compensationId=${parsedCompensationId}`
  //     );
      
  //     if (response.data && response.data.length > 0) {
  //       const fetchedCompensationId = response.data[0].CompensationId; // Assuming the API returns an array
  //       setCompensationId(fetchedCompensationId);
  //     } else {
  //       console.error("No Compensation Sub Type data found");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching Compensation Sub Type:", error);
  //   }
  // };

  // useEffect(() => {
  //   fetchCompensationDetails();
  // }, []);



  

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    // const formData = new FormData();
    // Object.entries(files).forEach(([key, file]) => {
    //   formData.append(key, file);
    // });

    try {
      debugger;
      alert("Save Manual Benficiary Data");
      setCurrentStep(3);
      navigate("/ProjectApprovalPendingList",  { state: { compensationId: compensationID } });
    } catch (err) {
      console.log("Error in Add Manual Benficiary Data:", err);
      setError(err.message);
      alert("Failed to Add Manual Benficiary Data");
    }
  };

  // Function to handle button click and simulate report generation
  const handleGenerateReport = () => {
    setLoading(true); // Set loading state to true when the button is clicked

    // Simulate a delay (e.g., API call or processing)
    setTimeout(() => {
      setLoading(false); // Reset loading state
      setSuccessMessage("Report generated successfully!"); // Set success message
    }, 3000); // 3 seconds delay
  };

  return (
    <div className="flex-1 px-6 py-4 overflow-auto">
      <div className="border-b pb-2 flex items-center justify-between text-xl font-bold">
        <h1>Submit Proposal</h1>
      </div>
      {/* <div className="mt-5">
          <h2 className="text-[#241C68] underline mb-4"> &#x25CF; Reference Letter Details(PIU Issued Letter):</h2>
          </div> */}
      <div className="mt-5">
        <small className="text-[#241C68] underline">PIU Issued Letter:</small>
      </div>
      {/* <div>
                <button className="border rounded-sm px-5 py-1 mt-5 hover:bg-[#241C68] hover:text-white">Generate Letter</button>
            </div> */}
      <div className="container">
        {/* Generate Letter Button */}
        <button
          className="border rounded-sm px-5 py-1 mt-5 hover:bg-[#241C68] hover:text-white"
          onClick={handleGenerateReport} // Trigger the report generation on click
          disabled={loading} // Disable button while loading
        >
          {loading ? "Processing..." : "Generate Letter"}
        </button>

        {/* Success Message (Popup or Alert) */}
        {successMessage && (
          <div className="mt-4 p-4 bg-green-200 text-green-700 rounded">
            {successMessage}
          </div>
        )}
      </div>
      <div className="mt-1">
                        <small className="text-[#117FE5] underline"
                         ><a 
                        // href={`https://reporturrda.sarmar.co.in/Report/MyReport.aspx?CompensationId=${compensationID}`} 
                        href={`https://reporturrda.sarmar.co.in/Report/MyReport.aspx?CompensationId=${compensationID}`} 
                        target="_blank" 
                         rel="noopener noreferrer"
                         >View Report</a></small>
                    </div>
      {/* <div className="mt-1">
        <small className="text-[#117FE5] underline">
          {compensationId ? (
            <a
              href={`https://reporturrda.sarmar.co.in//Report/MyReport.aspx?CompensationId=${compensationId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              View Report
            </a>
          ) : (
            "Loading..."
          )}
        </small>
      </div> */}
      {/* <div className="mt-1">
  <small className="text-[#117FE5] underline">
    {CompensationId ? (
      <a
        href={`https://reporturrda.sarmar.co.in//Report/MyReport.aspx?CompensationId=${CompensationId}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        View Report
      </a>
    ) : (
      "Loading Report..."
    )}
  </small>
</div> */}

      <div className="justify-items-center text-center">
        <button
          onClick={handleSubmit}
          className="border px-5 py-3 bg-[#241C68] rounded-lg text-xl text-white w-96 mt-3.5 "
        >
          Submit Proposal
        </button>
      </div>
    </div>
  );
};

export default SubmitProposal;
